$(document).ready(function(){
    function initializeCarousel(selector, options) {
        $(selector).addClass("owl-carousel owl-theme").owlCarousel(options);
    }

    // Carousel 1
    initializeCarousel('.press-slider div.page-width div.custom-content', {
        loop: true,
        autoplay: true,
        autoplayTimeout: 10000,
        slideSpeed: 500,
        smartSpeed: 1000,
        margin: 10,
        autoHeight: true,
        center: true,
        responsive: {
            0: { items: 1, autoplay: false },
            600: { items: 1 },
            1000: { items: 1 }
        }
    });

    // Carousel 2
    initializeCarousel('.product-list-collection.new-layout-up .grid', {
        loop: false,
        autoplay: false,
        slideSpeed: 500,
        smartSpeed: 1000,
        margin: 10,
        nav: true,
        dots: false,
        items: 1,
        center: false,
        navText: [
            '<i class="fa fa-chevron-circle-left" aria-hidden="true"></i>',
            '<i class="fa fa-chevron-circle-right" aria-hidden="true"></i>'
        ],
        responsive: {
            0: { items: 1 },
            600: { items: 1 },
            900: { items: 3 }
        }
    });

    // Carousel 3
    initializeCarousel('#shopify-section-16409055317d6646bc div.page-width div.custom-content', {
        loop: true,
        autoplay: true,
        autoplayTimeout: 4000,
        slideSpeed: 500,
        smartSpeed: 1000,
        margin: 10,
        autoHeight: false,
        center: true,
        nav: false,
        stagePadding: 400,
        items: 1,
        responsive: {
            0: {
                margin: 15,
                autoplay: false,
                items: 1,
                autoHeight: true,
                stagePadding: 0
            },
            769: { margin: 0, items: 1, stagePadding: 0 },
            900: { stagePadding: 250, items: 1 },
            1200: { stagePadding: 400, items: 1, margin: 40 },
            1550: { stagePadding: 530, items: 1, margin: 40 },
            1800: { stagePadding: 600, items: 1, margin: 40 }
        }
    });
});


 function updateBundleProductClass(dataId) {
    // Remove all existing classes from bundle-product
    const bundleProduct = document.querySelector('.bundle-product');
    bundleProduct.className = 'bundle-product'; // Reset the classes
    
    // If dataId exists, add it as a class to bundle-product
    if (dataId) {
        bundleProduct.classList.add(dataId);
    }
}

// Function to get the data-id of the active tab-title
function getActiveTabDataId() {
    const activeTab = document.querySelector('.tab-men-title.active');
    return activeTab ? activeTab.getAttribute('data-id') : null;
}

// Call the function when the page loads
window.addEventListener('DOMContentLoaded', function() {
    const activeDataId = getActiveTabDataId();
    updateBundleProductClass(activeDataId);
});

// Add a click event listener to .tab-men-title elements
document.querySelectorAll('.tab-men-title').forEach(function(tab) {
    tab.addEventListener('click', function() {
        // Get the data-id attribute value of the clicked tab
        const dataId = tab.getAttribute('data-id');
        // Call the function when any .tab-men-title is clicked
        updateBundleProductClass(dataId);
    });
});

$('.site-nav--has-dropdown').on('click', function() {
 
    if($(this).hasClass('active-menu')) {
   
      $(this).removeClass('active-menu');
    }
    else {

      $('.site-nav--has-dropdown').removeClass('active-menu');
  
      $(this).toggleClass('active-menu');
    }
});   

$('.btn--link.site-header__icon').on('click', function() {
 
  $('.site-nav--has-dropdown').removeClass('active-menu');
  
});   


  

  